const useHandleContextualNotEmbedded = () => {
  const hide = () => {};
  const show = () => {};
  const leaveConfirmation = () => {};
  return {
    hide,
    show,
    leaveConfirmation,
  };
};

// const useHandleContextual = () => {
//   const shopify = useAppBridge();
//   const hide = () => {
//     shopify?.saveBar?.hide(EstElementId.SaveBar);
//   };

//   const show = () => {
//     shopify?.saveBar?.show(EstElementId.SaveBar);
//   };

//   const leaveConfirmation = () => {
//     shopify?.saveBar?.leaveConfirmation();
//   };

//   return {
//     hide,
//     show,
//     leaveConfirmation,
//   };
// };

// export default isEmbedded ? useHandleContextual : useHandleContextualNotEmbedded;
export default useHandleContextualNotEmbedded;
